import { Helmet } from 'react-helmet';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Box, Container, Button } from '@material-ui/core';
import CustomerListResults from 'src/components/customer/CustomerListResults';
import customers from 'src/__mocks__/customers';
import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import './style.scss';
import { SEARCH_ACCOUNT } from "../../apiContants";

/* eslint-disable camelcase */
const CustomerList = () => {
  const [reg, regSet] = useState(Array);

  const getinfor = async () => {
    const total_mint = await axios.get(SEARCH_ACCOUNT);
    const datas = total_mint.data.accounts;
    regSet(datas);
  };
  useEffect(() => {
    getinfor();
  }, []);
  const _export = React.useRef(null);
  /* eslint no-underscore-dangle: 0 */
  const excelExport = () => {
    if (_export.current !== null) {
      _export.current.save();
    }
  };
  return (
    <>
      <Helmet>
        <title>Customers | Material Kit</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          {/* <CustomerListToolbar /> */}
          <Button
            type="button"
            title="Export Excel"
            color="primary"
            variant="contained"
            onClick={excelExport}
          >
            Export to Excel
          </Button>
          <Box sx={{ pt: 3 }}>
            <CustomerListResults customers={reg} />
          </Box>
          <div className="hidden">
            <Box sx={{ pt: 3 }}>
              <ExcelExport data={reg} ref={_export}>
                <Grid data={reg} style={{ height: "420px" }}>
                  <GridToolbar>
                    <button
                      type="button"
                      title="Export Excel"
                      className="k-button k-primary"
                      onClick={excelExport}
                    >
                      Export to Excel
                    </button>
                  </GridToolbar>
                  <GridColumn field="address" title="wallet ADD" width="50px" />
                  <GridColumn
                    field="username.String"
                    title="User Name"
                    width="350px"
                  />
                  <GridColumn field="status" title="User Status" />
                  <GridColumn field="email" title="Register day" />
                  <GridColumn field="value" title="Wallet Value" />
                  <GridColumn field="instagram" title="Created items" />
                  <GridColumn field="twitter" title="Sale-on items" />
                  <GridColumn field="registerdate" title="Bought items" />
                  <GridColumn field="registerdate" title="Sold items" />
                </Grid>
              </ExcelExport>
            </Box>
          </div>
        </Container>
      </Box>
    </>
  );
};

export default CustomerList;
